
import { createTheme } from '@mui/material/styles/index.js';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1a237e',
    },
    secondary: {
      main: '#b71c1c',
    },
  },
});

export default theme;
